module.exports = {
	'bootstrap': require('./lib/bootstrap-variables.json')
}



//////////////////
// WEBPACK FOOTER
// ./~/toetag/index.js
// module id = 554
// module chunks = 0